import { Component, Input } from '@angular/core';
import { emptyFunction } from '@libs/functions';
import { FormGroup } from '@angular/forms';


export interface AbstractFormHandlers {
    handlerSave?: <T>(body: T) => void;
    handlerCreate?: <T>(body: T) => void;
    handlerSubmit?: <T>(body: T) => void;
}

@Component({
    selector: 'ui-abstract-form',
    imports: [],
    templateUrl: './abstract-form.component.html',
    styleUrl: './abstract-form.component.scss',
})
export class AbstractFormComponent {
    #pending: boolean = false;
    /**
     * Read-only mode flag
     */
    @Input() public lyView: boolean;
    /**
     * Form edit entity flag
     */
    @Input() public isEditMode: boolean;
    /**
     * Form handlers
     */
    @Input() public handlers: AbstractFormHandlers;

    /**
     * Server pending flag
     */
    @Input() public set pending(pending: boolean) {
        this.#pending = pending;

        if (this.form) {
            if (pending) {
                this.form.markAsPending();
            } else {
                this.form.updateValueAndValidity();
            }
        }
    }

    public get pending(): boolean {
        return this.#pending;
    }

    public readonly form: FormGroup;

    public handlerCreate: () => void = emptyFunction;
    public handlerSave: () => void = emptyFunction;
    public handlerSubmit: () => void = emptyFunction;
}
